let items = [ 
    {
        id: 0,
        name: "Apple iPad Mini 2 16GB",
        description: "An iPad like no other. 16GB, WiFi, 4G.", 
        price: 229.00,
        image: '/assets/images/Apple iPad Mini 2 16GB.jpeg'
    }, 
    {
        id: 1,
        name: "Apple iPad Mini 2 32GB", 
        description: "Even larger than the 16GB.", 
        price: 279.00,
        image: '/assets/images/Apple iPad Mini 2 32GB.jpg'
    }, 
    {
        id: 2,
        name: "Canon T7i",
        description: "DSLR camera with lots of megapixels.", 
        price: 749.99,
        image: '/assets/images/Canon T7i.jpg'
    }, 
    {
        id: 3,
        name: "Apple Watch Sport", 
        description: "A watch", 
        price: 249.99,
        image: '/assets/images/Apple Watch Sport.jpeg'
    }, 
    {
        id: 4,
        name: "Apple Watch Silver", 
        description: "A more expensive watch", 
        price: 599.99,
        image: '/assets/images/Apple Watch Silver.jpeg'
    } 
];

export {items};